import React, {Component} from 'react';
import { FormDataObj, FormLabeledItem, Button, Input, CheckBox, DateInputSelect } from '../../components/FormUI';
import { SanitizeClassNames } from '../../common';
import './FollowUpView.css';

import FollowUpService from '../../api/services/FollowUpService';
import User from '../../api/User';
import Icon from '../../components/Icon';
import PatientService from '../../api/services/PatientService';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import ClinicPatientList from '../../components/datalists/ClinicPatientList';
import AccountService from '../../api/services/AccountService';
import UserFollowUpView from './UserFollowUpView';

const pService = new PatientService(true);
const account = new AccountService();

function parseFollowUps(fu){
    console.log("Parse Followups:", fu)
    let o = [];
    for(let patientId in fu){
        let ass = fu[patientId].assessments.pop();
        o.push({patientId:patientId, date:ass.followups.pop().created, followup:ass})
    }
    return o;
}

export default class FollowUpView extends Component{
    state = {};
    clinicId =  account.clinicId;
    componentDidMount(){
        //console.log('Calendar View did Mount!!!!!!!!!!!')
        if(this.props.onSectionHeader){
            this.props.onSectionHeader(<h2 className='client-view-section-header'>Follow Ups</h2>)
        }

        this.refreshList();
    }

    refreshList = ()=>{
        FollowUpService.GetFollowUps().then((json)=>{
            this.setState({followups:parseFollowUps(json)});
        })
    }

    componentDidUpdate(prevProps, prevState){
        if(this.clinicId != account.clinicId){
            this.clinicId = account.clinicId;
            this.refreshList();
        }
        
    }

    handleListItemClick = (user, followup)=>{
        console.log("FollowUpView: handleListItemClick  ", followup)
        this.setState({selected:{user:user, followup:followup}});
    }

    handleBack = ()=>{
        this.setState({selected:null});
    }

    render(){
        let view = null;

        if(this.state.selected){

            view = <div className='follow-ups'>
                        <UserFollowUpView followup={this.state.selected} />
                    </div>
        }
        
        /*else{
            view = <div className='follow-ups'>
                        <h1>Follow Ups</h1>
                        <FollowUpList list={this.state.followups} onSelect={this.handleListItemClick} />
                    </div>;
        }*/

        return(
            <div className={SanitizeClassNames(this, 'followup-view')}>
                <div className="table hmax follow-ups">
                    <div>
                        <div>
                            <div>
                                <FollowUpList list={this.state.followups} onSelect={this.handleListItemClick} />
                            </div>
                        </div>
                        <div>
                            {view}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export class FollowUpForm extends Component{
    form = new FormDataObj();
    state = {errors:{}};
    handleSubmit = ()=>{
        if(this.state.isBusy)return;
        //console.log('Follow up Reminder:', this.form.data);
        let errors = this.form.getErrorState();
        //console.log("Errors:", errors)
        if(errors == null){
            this.setState({isBusy:true});
            FollowUpService.CreateReminder(this.form.data).then((reminder)=>{
                //console.log("Reminder Created! ", reminder);
                this.setState({isBusy:false});
                if(this.props.onUpdate){
                    this.props.onUpdate(reminder);
                }

                NotificationManager.success('Reminder added successfully.', 'Follow Up Reminder');
            })
        }
        this.setState({errors:errors || {}});
        
    }

    render(){
        return(
            <div className={SanitizeClassNames(this, 'followup-form')}>
                <FormLabeledItem label='Add New Follow Up Reminder'>
                    <div className='table hmax form-layout'>
                        <div>
                            <div>
                                <FormLabeledItem label='Patient'>
                                    <ClinicPatientList simpleValue={true} name='patientId' form={this.form} error={this.state.errors['patientId']} required />
                                </FormLabeledItem>
                            </div>
                            <div>
                                <FormLabeledItem label='Time Frame'>
                                    <DateInputSelect name='date' form={this.form} format='ddd, MMMM D, YYYY' error={this.state.errors['date']} value={moment()}  required />
                                    
                                </FormLabeledItem>
                            </div>
                        </div>
                        <div>
                            <div>
                                <FormLabeledItem label='Reason'>
                                    <Input  name='description' form={this.form} />
                                </FormLabeledItem>
                            </div>
                            <div>
                                <FormLabeledItem label='&nbsp;'>
                                    <Button className='green submit' caption='Create Follow Up Reminder' onClick={this.handleSubmit} isBusy={this.state.isBusy}/>
                                </FormLabeledItem>
                            </div>
                        </div>
                        <div>
                            <div></div>
                            <div>
                                <CheckBox label='Email me this reminder on date of' />
                            </div>
                        </div>
                    </div>
                </FormLabeledItem>
            </div>
        )
    }
}

class FollowUpList extends Component{
    state = {};
    handleSelect = (user, followup) => {
        console.log("FollowUpList: handleSelect");
        if(this.props.onSelect){
            this.props.onSelect(user, followup);
        }
    }
    render(){

        ///console.log('All Follow Ups:', json);
        let items = [];
        let json = this.props.list || [];
        json.sort((a, b) => {

            if(moment(a.date).isSame(moment(b.date)))return 0;
            return (moment(a.date).isBefore(moment(b.date)))? 1:-1;
        });
        let groups = {};
        for(let i=0; i < json.length; i++){
            let reminder = json[i];
            let groupId = moment(reminder.date).format('MMMM Y');
            if(groups[groupId] === undefined){
                groups[groupId] = [];
            }
            groups[groupId].push(<FollowUpListItem followup={reminder} onSelect={this.handleSelect} />);
        }

        for(let p in groups){
            items.push(
                <div className='list-group'>
                    <h2>{p}</h2>
                    {groups[p]}
                </div>
            )

        }

        return(
            <div className='followup-list'>{items}</div>
        )
    }
}


/*class FollowUpList extends Component{
    state = {};
   
    render(){

        ///console.log('All Follow Ups:', json);
        let items = [];
        let json = this.props.list || [];
        
        for(let p in json){
            let reminder = json[p];
            
            items.push(<FollowUpListItem reminder={reminder} />);
        }

        

        return(
            <div className='followup-list'>{items}</div>
        )
    }
}*/

const contactParse = {email:'email', phone:'homePhone', cell:'cell', work:'workPhone'}
const iconParse = {email:'emailGrey', phone:'phoneGrey', work:'phoneGrey', cell:'textGrey'}

export class FollowUpListItem extends Component{
    state = {};
    componentDidMount(){
        //console.log("Follow Up Item:", this.props.reminder);
        pService.getById(this.props.followup.patientId).then((patient)=>{

            //console.log("Follow Up Item Patient " + this.props.reminder.patientId + ":", patient)
            this.setState({user:new User(patient)});
        });
    }

    handleClick = ()=>{
        if(this.props.onSelect && this.state.user){
            this.props.onSelect(this.state.user, this.props.followup);
        }
    }
    render(){
        let name = <span className="Select-loading"></span>;
        let contact = '--';
        let icon = '';
        if(this.state.user){
            let user = this.state.user;
            name = user.fullName;
            icon = iconParse[user.preferredContactMethod];
            contact = user[contactParse[user.preferredContactMethod]];
        }
        return(
            <div className='followup-list-item table hmax align-middle' onClick={this.handleClick}>
                <div>
                    <div className='hmax'><div>{name}</div><div>{this.props.followup.description}</div></div>
                    <div>{contact}</div>
                    <div><Icon icon={icon} /></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/followup/FollowUpView.js